<template>
  <div class="page-box">
    <Header />
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/shopkeeper/banner.png')})` }">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-1" :style="titleStyle">{{ titleRow1 }}</div>
          <div class="title-2">依托数智化中台与 TOP 品牌资源<br>
            以私域 + 实体双驱 打造市场高效供货与全域增长链路</div>
          <div class="title-3">
            立即申请入驻
          </div>
        </div>
      </div>

    </div>
    <div class="flor2" data-aos="fade-up"
      :style="{ backgroundImage: `url(${require('@/assets/product/shopkeeper/banner2.png')})` }">
      <div class="f2-title">关于AI超级店长</div>
      <div class="f2-subtitle">AI超级店长是汇通达B2B事业部核心业务，依托汇通达下沉市场产业互联网优势，以私域+实体双轮驱动为核心，打造全渠道增长链路，<br>
        助力品牌方实现流量到销量的一站式跃迁，精准触达下沉消费群体。</div>
    </div>

    <div class="flor3" data-aos="fade-up">
      <div class="f2-title">AI超级店长业务架构全景</div>
      <div class="f2-subtitle">AI超级店长构建技术赋能为底层、供应链为核心、私域+实体为双引擎的业务架构，实现品牌方、团长/店主、消费者的价值闭环</div>

      <div style="display: flex;align-items: center;flex-direction: column;">
        <div style="display: flex;flex-direction: row;">
          <div class="f3-card"
            :style="{ backgroundImage: `url(${require('@/assets/product/shopkeeper/f3-card-1.png')})` }">
            <div class="title">基础支撑层</div>
            <div class="subtitle">背靠汇通达港股上市平台（9878.HK），获阿里45亿战略投资，拥有AI数智化中台与1000+TOP品牌智慧供应链，实现F2B2C极致短链降本。</div>
          </div>
          <div style="width: 20px;"></div>
          <div class="f3-card"
            :style="{ backgroundImage: `url(${require('@/assets/product/shopkeeper/f3-card-2.png')})` }">
            <div class="title">线下实体层</div>
            <div class="subtitle">覆盖全国21省、2.6万+乡镇、25.1万+会员店，乡镇门店密度超60%，配备专业线下团队提供贴身运营服务，年销目标超200亿。</div>
          </div>
        </div>
        <div style="height: 20px;"></div>
        <div style="display: flex;flex-direction: row;">
          <div class="f3-card"
            :style="{ backgroundImage: `url(${require('@/assets/product/shopkeeper/f3-card-3.png')})` }">
            <div class="title">线上私域层</div>
            <div class="subtitle">打造30万+活跃团长的全域分销网络，覆盖500+城市，头部团长年销超50亿，以私域团长分销、中央直播为核心，搭配分层运营、1V1服务等配套体系激活流量。</div>
          </div>
          <div style="width: 20px;"></div>
          <div class="f3-card"
            :style="{ backgroundImage: `url(${require('@/assets/product/shopkeeper/f3-card-4.png')})` }">
            <div class="title">业务场景层</div>
            <div class="subtitle">聚焦消费电子、家电、美妆个护等核心品类，打造特色主题IP，结合月度/周度裂变活动，打通线上直播、社群分销与线下门店自提/配送，完成全场景销售闭环。</div>
          </div>
        </div>

      </div>
    </div>


    <div class="flor4" style="margin-top: 160px;" data-aos="fade-up">
      <div class="f2-title">私域团长分销 · 下沉市场高效增长引擎</div>
      <div class="f2-subtitle">依托社区熟人社交+门店实体背书，构建店主端激励、消费者端裂变、平台端赋能的增长闭环，<br>
        实现私域流量可持续变现，为品牌方打造下沉市场私域分销核心渠道</div>
      <div style="display: flex;flex-direction: row;">
        <div style="display: flex;flex-direction: column;align-items: start;">
          <div class="f4-b-title">核心优势</div>

          <div style="margin-top: 50px;" />
          <div style="display: flex;flex-direction: row;">
            <img style="width: 22px;height: 16px;" src="@/assets/product/shopkeeper/f4-2.png" />
            <div class="f4-title">超大规模覆盖</div>
          </div>
          <div class="f4-subtitle">30万+活跃团长，覆盖500+城市，月均订单100万+、销售额5000万+，品牌触达率提升35%，下沉转化效率较传统渠道高22%。</div>

          <div style="margin-top: 50px;" />
          <div style="display: flex;flex-direction: row;">
            <img style="width: 22px;height: 16px;" src="@/assets/product/shopkeeper/f4-2.png" />
            <div class="f4-title">双向激励体系</div>
          </div>
          <div class="f4-subtitle">店主端阶梯佣金、等级晋升、战队PK;消费者端分享有礼、社群互动、专属优惠，推动主动裂变。</div>

          <div style="margin-top: 50px;" />
          <div style="display: flex;flex-direction: row;">
            <img style="width: 22px;height: 16px;" src="@/assets/product/shopkeeper/f4-2.png" />
            <div class="f4-title">全维度平台赋能</div>
          </div>
          <div class="f4-subtitle">一键分享海报、订单追踪等轻量化工具;团长分层培训+产品素材库+社群SOP;1V1运营顾问全程跟进活动策划与数据复盘。</div>

        </div>
        <div>
          <img style="width: 645px;height: 464px;" src="@/assets/product/shopkeeper/f4-1.png" />
        </div>


      </div>
      <div style="width: 1200px;height: 282px;">
        <img style="width: 1200px;height: 282px;" src="@/assets/product/shopkeeper/f4-3.jpg">
      </div>
    </div>

    <div class="flor4" style="margin-top: 160px;" data-aos="fade-up">
      <div class="f2-title">中央直播 · 零成本全域引流转化渠道</div>
      <div class="f2-subtitle">为供应商打造零成本曝光+全域引流+精准转化专属直播渠道，全托管运营打通直播与线下分销订单，<br />
        实现“直播种草+门店履约”的销售闭环，让品牌方轻松做直播、高效做转化。</div>
      <div style="display: flex;flex-direction: row;">
        <div style="display: flex;flex-direction: column;align-items: start;">
          <div class="f4-b-title">核心优势</div>

          <div style="margin-top: 50px;" />
          <div style="display: flex;flex-direction: row;">
            <img style="width: 22px;height: 14px;" src="@/assets/product/shopkeeper/f4-2.png" />
            <div class="f4-title">零门槛全托管</div>
          </div>
          <div class="f4-subtitle">品牌无需自建直播团队，平台提供策划、运营、复盘一站式服务，大幅降低运营成本与门槛。</div>

          <div style="margin-top: 50px;" />
          <div style="display: flex;flex-direction: row;">
            <img style="width: 22px;height: 14px;" src="@/assets/product/shopkeeper/f4-2.png" />
            <div class="f4-title">全域流量引爆</div>
          </div>
          <div class="f4-subtitle">联动25.1万+线下门店、30万+团长私域，单场直播最高观看数破百万，新增会员超2.2万。</div>

          <div style="margin-top: 50px;" />
          <div style="display: flex;flex-direction: row;">
            <img style="width: 22px;height: 14px;" src="@/assets/product/shopkeeper/f4-2.png" />
            <div class="f4-title">千店联动转化</div>
          </div>
          <div class="f4-subtitle">定向匹配门店资源，支持直播订单自提/配送，依托实体信任提升转化，人均观看时长达32分35秒。</div>

          <div style="margin-top: 50px;" />
          <div style="display: flex;flex-direction: row;">
            <img style="width: 22px;height: 14px;" src="@/assets/product/shopkeeper/f4-2.png" />
            <div class="f4-title">数据驱动运营</div>
          </div>
          <div class="f4-subtitle">专属数据看板，实时监控观看、订单、销售额等核心数据，精准优化直播运营策略。</div>

        </div>
        <div>
          <img style="width: 640px;height: 566px;" src="@/assets/product/shopkeeper/f5-1.jpg" />
        </div>


      </div>
      <div style="width: 1200px;height: 282px;">
        <img style="width: 1200px;height: 282px;" src="@/assets/product/shopkeeper/f5-2.jpg">
      </div>
      <div style="height: 160px;"></div>
    </div>

    <div data-aos="fade-up" style="width: 100%;height: auto;">
      <img style="width: 100%;height: auto;" src="@/assets/product/shopkeeper/f6.jpg" />
    </div>

    <div class="flor7">
      <div class="title">合作品牌</div>
      <img style="width: 1200px;height: 860px;margin-top: 54px;margin-bottom: 120px;"
        src="@/assets/product/shopkeeper/f7.jpg" />
    </div>

    <div class="flor8">
      <div class="title">合作流程：销量评估&合作签约</div>
      <img style="width: 946px;height: 30px;margin-top: 38px;margin-bottom: 20px;"
        src="@/assets/product/shopkeeper/f8-1.png" />
      <div class="card-cn">
        <div class=" card">
          <img src="@/assets/product/shopkeeper/f8-21.png" />
          <div class="title">品牌销量评估</div>
          <div class="subtitle">基于评估结果，提供包含私域引流策略、社群运营方案、用户裂变玩法、内容种草计划的一站式合作方案，同步明确平台流量扶持、运营培训等赋能权益。</div>
        </div>
        <div class=" card">
          <img src="@/assets/product/shopkeeper/f8-21.png" />
          <div class="title">私域全案定制输出</div>
          <div class="subtitle">品牌方提报核心品类销量统计表，平台结合汇享购私域用户画像与品牌调性，开展匹配度分析，制定品牌专属私域销售预估表。</div>
        </div>
        <div class=" card">
          <img src="@/assets/product/shopkeeper/f8-21.png" />
          <div class="title">合作协议正式签约</div>
          <div class="subtitle">明确双方在私域运营、数据共享、售后保障、收益分成等方面的权责，准备相关资质材料、缴纳服务费用，完成入驻审核。</div>
        </div>
        <div class=" card">
          <img src="@/assets/product/shopkeeper/f8-21.png" />
          <div class="title">账号激活上架</div>
          <div class="subtitle">完成品牌账号开通、商品上架及店铺装修，同步启动私域冷启动支持，包括首期社群搭建、种子用户招募、开业促销活动策划，助力品牌快速实现私域破单。</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Banner from '@/assets/product/shopkeeper/banner.png'
import BusinessCharacteristics from '@/assets/product/digitalSystem/business-characteristics.png'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TopBanner from './components/topBanner.vue'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import CardItem from './components/cardItem.vue'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import DSUpModule from './components/dsUpModule.vue'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import SimpleCance from '@/assets/home/check.svg'
import OneStopBanner from '@/assets/product/digitalSystem/One-Stop-banner.png'
import metaInfo from "@/common/util/metaInfo"
export default {
  metaInfo: metaInfo.aiShopkeeper,
  components: {
    Header,
    Footer,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    ModuleBgBlue,
    DSUpModule
  },
  data() {
    return {
      OneStopBannerImg: OneStopBanner,
      simpleCanceImg: SimpleCance,
      CancelImg: Cancel,
      BannerImg: Banner,
      BusinessCharacteristicsImg: BusinessCharacteristics,
      title2: "",
      titleRow1: 'AI超级店长',
      titleRow2: '',
      blueText: '',
      titleTipsList: [

      ],
      moduleTipsList: [
        {
          name: '企业交易中的常见痛点'
        }
      ],
      painList: [
        {
          icon: require("@/assets/product/svgIcon/pain-spot-1.svg"),
          name: '线下沟通',
          imgShow: false,
          descList: [
            '电话或微信沟通，产品信息多，型号容易出错，发错货品',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/pain-spot-2.svg"),
          name: '库存积压',
          imgShow: false,
          descList: [
            '传统经销商要大量压货，确保型号齐全满足客户要求',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/pain-spot-3.svg"),
          name: '对接流程繁琐',
          imgShow: false,
          descList: [
            '客户大量询单，需要专人对接，频繁查询价格和库存，客户缺乏体验感',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/pain-spot-4.svg"),
          name: '渠道管控',
          imgShow: false,
          descList: [
            '强渠道管控逻辑，渠道价格及销售政策差异性大，严控渠道串货',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/pain-spot-5.svg"),
          name: '线下转账繁琐',
          imgShow: false,
          descList: [
            '线下大额转账繁琐，需要专人对接核对，人工认领核对工作量较大',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/pain-spot-6.svg"),
          name: '客户价值分析缺失',
          imgShow: false,
          descList: [
            '缺少客户的价值体系分析，数据不完整，无法进行有效的决策',
          ]
        }
      ],
      titleDescStype: {
        color: '#fff',
        opacity: 0.7
      },
      ModuleTitleStype: {
        marginBottom: '40px'
      },
      advantageCardStyle: {
        backgroundColor: '#fff',
        height: '250px'
      },
      advantageList: [
        {
          icon: require("@/assets/product/svgIcon/core-advantages-1.svg"),
          name: '多层级授权体系',
          imgShow: true,
          descList: [
            '交易通路全覆盖，支持不同类型客户的封闭及开放交易',
            '更好地管理其供应链，优化客户关系',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/core-advantages-2.svg"),
          name: '多模式经营',
          imgShow: true,
          descList: [
            '自营模式、pop模式、品牌垂直直营',
            '在不同市场环境和客户需求下可持续发展',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/core-advantages-3.svg"),
          name: '多段交易在线',
          imgShow: true,
          descList: [
            '各段交易全流程在线闭环，具备完整交易记录和数据追踪',
            'B2F集单反采,快速收集订单智能排产，提高产能利用率',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/core-advantages-4.svg"),
          name: '品类授权体系+价格管控',
          imgShow: true,
          descList: [
            '满足品牌分品类授权和区域管控要求',
            '具备多种价格管理方式，如区域价、阶梯价、会员价等',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/core-advantages-5.svg"),
          name: '营销政策',
          imgShow: true,
          descList: [
            '灵活的分销管理政策机制的制定,如返利政策、配货策略、配额管理等',
            '具备行业特点的运营策略，如竞价销售、行情分析',
          ]
        },
        {
          icon: require("@/assets/product/svgIcon/core-advantages-6.svg"),
          name: '360度用户画像',
          imgShow: true,
          descList: [
            '以数据为业务决策依据，服务客户差异化销售策略',
            '收集、分析客户在线行为，实现客户的全生命周期管理及随时触达',
          ]
        }
      ]
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
.center-box {
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: left;
  font-size: 14px;
  color: #3E4755;
  line-height: 19px;
  padding-top: 106px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
}

.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.page-box {
  background-color: #fff;
}

.page-content {
  // margin-bottom: 70px;
}

.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 100px;
}

.showImg {
  width: 100%;
  height: auto;
  margin-bottom: 100px;
}

.core-advantages {
  padding: 71px 0 0 0;
}

.mg-btm-70 {
  margin-bottom: 70px;
}

.mg-btm-40 {
  margin-bottom: 40px;
}

.multi-mode {
  width: 100%;
  height: 700px;
  margin-bottom: 70px;
}

.multi-mode-item {
  width: 380px;
  height: 410px;
  text-align: left;
  position: relative;
  background: #fff;
  border-radius: 6px;
}

.mask-layer {
  position: absolute;
  top: 220px;
  left: 0;
  width: 100%;
  height: 20px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, #FFFFFF 100%);
}

.multi-mode-item-img {
  width: 380px;
  height: 240px;
  overflow: hidden;
  margin-bottom: 12px;
}

.multi-mode-item-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 21px;
  padding: 0px 30px;
}

.multi-mode-item-desc {
  font-size: 14px;
  color: #222222;
  line-height: 22px;
  padding: 0px 30px;
}

/* 商品管理 */
.goods-manage-ilne {
  display: flex;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}

.item-ilne-icon {
  width: 22px;
  height: 16px;
  margin-right: 10px;
}

.item-ilne-title {
  display: inline-block;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}

.item-ilne-content {
  width: 220px;
}

.goods-manage-mid-img {
  width: 600px;
  height: 480px;
}

.goods-manage-item {
  box-sizing: border-box;
  height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 53px 0;
}

/* 多种价格策略 */
.multi-price-strategy {
  width: 100%;
  height: 660px;
  margin-bottom: 70px;
}

.multi-price-strategy-flex {
  display: flex;
}

.multi-price-strategy-flex .img {
  width: 667px;
  height: 360px;
  margin-right: 100px;
}

.multi-price-strategy-content {
  text-align: left;
}

.multi-price-strategy-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 10px;
}

.multi-price-strategy-item {
  margin-bottom: 50px;
}

.multi-price-strategy-desc {
  display: flex;
  margin-bottom: 20px;
}

.multi-price-strategy-desc-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  margin-top: 3px;
}

.multi-price-strategy-desc-text {
  width: 322px;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}

/* 配额/配提灵活应用，促活跃去库存 */
.activity-box {
  width: 100%;
  height: 830px;
  padding-top: 70px;
}

.activity-content {
  text-align: left;
}

.activity-content .activity-content-item {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 100px;
}

.activity-content .activity-content-item .activity-content-left .title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 20px;
}

.activity-img {
  width: 640px;
  height: 200px;
}

.mg-right-115 {
  margin-right: 115px;
}

.mg-left-50 {
  margin-left: 50px;
}

/* 供求信息一站式对接 */
.One-Stop {
  height: 740px;
  width: 100%;
  min-width: 1200px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  padding-top: 70px;
}

.One-Stop .img {
  width: 1200px;
  height: 506px;
}

/* 用户属性+全触点数字行为，构建360°用户统一视图 */
.Underlay {
  width: 100%;
  height: 950px;
}

.Underlay .img {
  width: 1200px;
  height: 670px;
}

.flor2 {
  width: 100%;
  // min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  // justify-content: center;
  flex-direction: column;

  .f2-title {
    margin-top: 80px;
    margin-bottom: 35px;
    height: 34px;
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    font-style: normal;
  }

  .f2-subtitle {
    height: 60px;
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    font-style: normal;
  }
}

.flor3 {
  width: 100%;
  min-width: 1200px;
  height: 1090px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  background: #F4F5FB;
  // justify-content: center;
  flex-direction: column;

  .f2-title {
    margin-top: 80px;
    margin-bottom: 35px;
    height: 34px;
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    font-style: normal;
  }

  .f2-subtitle {
    height: 60px;
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    font-style: normal;
  }

  .f3-card {
    width: 580px;
    height: 380px;
    background-size: auto 100%;
    padding: 275px 20px 20px 20px;

    .title {
      // margin-top: 257px;
      margin-bottom: 27px;
      font-weight: bold;
      font-size: 22px;
      color: #222222;
      line-height: 22px;
      text-align: left;
    }

    .subtitle {
      font-size: 14px;
      color: #222222;
      line-height: 22px;
      text-align: justify;
    }
  }

}

.flor4 {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
align-items: center;

  .f2-title {
    margin-top: 80px;
    margin-bottom: 35px;
    height: 34px;
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    font-style: normal;
  }

  .f2-subtitle {
    height: 60px;
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    font-style: normal;
  }

  .f4-b-title {
    font-weight: bold;
    font-size: 24px;
    color: #222222;
    line-height: 46px;
  }

  .f4-title {
    font-weight: bold;
    font-size: 22px;
    color: #222222;
    line-height: 22px;
    margin-left: 15px;
  }

  .f4-subtitle {
    font-size: 14px;
    color: #595859;
    line-height: 22px;
    text-align: justify;
    margin-left: 37px;
    margin-top: 15px;
    width: 400px;
  }
}

.flor7 {
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
  }
}

.flor8 {
  padding: 70px 0 120px 0;
  background-color: #F4F5FB;


  .title {
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;

  }

  .card-cn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 20px;

    .card {
      width: 285px;
      height: 360px;
      background: #FFFFFF;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        margin-top: 30px;
        width: 200px;
        height: 123px;
      }

      .title {
        font-weight: bold;
        font-size: 18px;
        color: #222222;
        line-height: 22px;
        text-align: center;
        margin: 31px 0 12px 0;
      }

      .subtitle {
        font-size: 14px;
        color: #595859;
        line-height: 20px;
        text-align: justify;
        margin: 0 30px;
      }
    }
  }
}
</style>
